import { AssetEdit } from './AssetEdit';

export default AssetEdit;
